import { css } from '@emotion/react';
import React from 'react';
import { semantic_colors } from '../../foundation';
import { IconArrowChevronLeft, IconArrowChevronRight } from '../icons/generated';
import { useProviderConfig } from '../provider';
import { pagination_button_css, pagination_button_default_style, pagination_button_disabled_style } from './styles';

export type PaginationArrowDirection = 'prev' | 'next';

export interface PaginationArrowProps {
  /**
   * 이동 방향
   * @default 'prev'
   */
  direction?: PaginationArrowDirection;
  disabled?: boolean;
  onClick?: () => void;
}

export const PaginationArrow = ({ direction = 'prev', disabled, onClick }: PaginationArrowProps) => {
  const { locale } = useProviderConfig();
  const directionText = direction === 'prev' ? locale?.accessibility.prev : locale?.accessibility.next;
  const ariaLabel =
    locale?.lang === 'en-US'
      ? `${locale?.accessibility.page} ${directionText}`
      : `${directionText} ${locale?.accessibility.page}`;
  const color = disabled ? semantic_colors.content.disabled : semantic_colors.content.secondary;

  return (
    <button
      type='button'
      aria-label={ariaLabel}
      css={[
        pagination_button_css,
        pagination_button_default_style,
        css`
          cursor: ${disabled ? 'default' : 'pointer'};
          ${disabled && pagination_button_disabled_style}
        `,
      ]}
      disabled={disabled}
      onClick={onClick}
    >
      {direction === 'prev' ? (
        <IconArrowChevronLeft color={color} size={16} />
      ) : (
        <IconArrowChevronRight color={color} size={16} />
      )}
    </button>
  );
};
